import React from "react";

const IInfo = ({ color = "#252526", width = "12", height = "12", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M10.8125 6C10.8125 3.34213 8.65787 1.1875 6 1.1875C3.34213 1.1875 1.1875 3.34213 1.1875 6C1.1875 8.65787 3.34213 10.8125 6 10.8125C8.65787 10.8125 10.8125 8.65787 10.8125 6ZM11.6875 6C11.6875 9.14112 9.14112 11.6875 6 11.6875C2.85888 11.6875 0.3125 9.14112 0.3125 6C0.3125 2.85888 2.85888 0.3125 6 0.3125C9.14112 0.3125 11.6875 2.85888 11.6875 6Z"
        fill={color}
      />
      <path
        d="M6 0.75C8.89949 0.75 11.25 3.10051 11.25 6C11.25 8.89949 8.89949 11.25 6 11.25C3.10051 11.25 0.75 8.89949 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75ZM6 4.66585C5.67791 4.66585 5.41679 4.92713 5.41667 5.24919V8.625C5.41679 8.94706 5.67791 9.20833 6 9.20833C6.32209 9.20833 6.58321 8.94706 6.58333 8.625V5.24919C6.58321 4.92713 6.32209 4.66585 6 4.66585ZM6 2.79167C5.59729 2.79167 5.27083 3.11813 5.27083 3.52083C5.27083 3.92354 5.59729 4.25 6 4.25C6.40271 4.25 6.72917 3.92354 6.72917 3.52083C6.72917 3.11813 6.40271 2.79167 6 2.79167Z"
        fill={color}
      />
    </svg>
  );
};

export default IInfo;
